export default "__VITE_ASSET__DIzGUvXR__"